import { render, staticRenderFns } from "./SendCode.vue?vue&type=template&id=12e82d55&scoped=true&"
import script from "./SendCode.vue?vue&type=script&lang=js&"
export * from "./SendCode.vue?vue&type=script&lang=js&"
import style0 from "./SendCode.vue?vue&type=style&index=0&id=12e82d55&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e82d55",
  null
  
)

export default component.exports